import { HurdlrPlaidItemsData, HurdlrPlaidItemsParams } from './useHurdlrPlaidItems.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchPlaidItems = async (params?: HurdlrPlaidItemsParams): Promise<HurdlrPlaidItemsData> => {
    const { data } = await collectiveApi.get<HurdlrPlaidItemsData>('hurdlr/member/plaid-items/', {
        params,
    });

    return data;
};

export default fetchPlaidItems;
